import moment from 'moment';

export const getEndEventTime = (end_at: string): string => {
  const today = moment().unix();
  const ts = moment(end_at).unix();
  const cal = ts - today;

  if (cal < 0) return '종료된 이벤트입니다.';

  const min = cal / 60;
  const hour = min / 60;
  const day = hour / 24;
  const month = day / 30;
  const year = month / 12;

  if (min < 60) return `${Math.floor(min).toString()}분 남은 이벤트입니다.`;
  if (hour < 24) return `${Math.floor(hour).toString()}시간 남은 이벤트입니다.`;
  if (day < 30) return `${Math.floor(day).toString()}일 남은 이벤트입니다.`;
  if (month < 12) return `${Math.floor(month).toString()}달 남은 이벤트입니다.`;
  return `${Math.floor(year).toString()}년 남은 이벤트입니다.`;
};
